﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { Mate } from "@models/configurators/output-fields/cad/mates/mate";
import { eOutputFieldType } from "@models/enums";
import { ICadDistanceMate } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.CadDistanceMate, eOutputFieldType.cadDistanceMate)
export class CadDistanceMate extends Mate implements ICadDistanceMate {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public distance: number;
}
